var exports = {
  "_": "x93eb46d8--4ad5e2--thumbnails",
};

module.exports = exports;
